<template>
  <div>
        <a-card hoverable>
            <a-card-meta
                :title="title"
                :description="dataSource.desc">
                <a-avatar slot="avatar" style="backgroundColor:#1890ff" icon="cloud" />
            </a-card-meta>
            <a-row type="flex" style="margin-top:10px;">
                <a-col :span="6" class="title">总进度</a-col>
                <a-col :span="18"><a-progress :percent="ListStatus" :status="'normal'" size="small" /></a-col>
            </a-row>
            <div class="robot-list" v-if="open">
                <a-row type="flex" v-for="item in dataSource.list" :key="item.id" style="margin:5px 0;">
                    <a-col :span="6" class="title">{{item.id}}</a-col>
                    <a-col :span="18">
                        <a-tooltip placement="left" >
                            <template slot="title">
                                <span>（ID：{{item.id}}）{{item.msg}}</span>
                            </template>
                            <a-progress :percent="item.status | getItemPercent" :status="item.status | getItemStatus" size="small"/>
                        </a-tooltip>
                    </a-col>
                </a-row>
            </div>
            <div class="open-show" @click="toggle">
                <a-icon type="caret-up" v-if="open"/>
                <a-icon type="caret-down" v-else/>
            </div>
            <div class="close-btn" @click="onDelete">
                <a-icon type="close" />
            </div>
        </a-card>
  </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        dataSource: Object
    },
    data () {
        return{
            open: true
        }
    },
    computed: {
        title(){
            const list = this.dataSource.list
            const statusArr = Object.keys(list).map((id)=>{
                return list[id]['status']
            })
            let arr = []
            let waitArr = []
            statusArr.forEach(status => {
                if((status === 2)||(status === 3)){
                    arr.push(status)
                }else{
                    waitArr.push(status)
                }
            })
            if(waitArr.length > 0){
                return '执行中'
            }else{
                return '执行完成'
            }
        },
        ListStatus() {
            const list = this.dataSource.list
            const statusArr = Object.keys(list).map((id)=>{
                return list[id]['status']
            })
            let arr = []
            statusArr.forEach(status => {
                if((status === 2)||(status === 3)){
                    arr.push(status)
                }
            })
            return (arr.length / statusArr.length)*100
        }
    },
    filters: {
        getItemStatus(status) {
            if(status === 0){
                return 'normal'
            }else if(status === 1){
                return 'active'
            }else if(status === 2){
                return 'success'
            }else if(status === 3){
                return 'exception'
            }
        },
        getItemPercent(status) {
            if(status === 0){
                return 0
            }else if(status === 1){
                return 50
            }else if(status === 2){
                return 100
            }else if(status === 3){
                return 100
            }
        }
    },
    mounted () {

    },
    methods: {
        toggle(){
            this.open = !this.open
        },
        onDelete() {
            this.$emit('delete')
        }
    }
}
</script>

<style lang="less" scoped>
.ant-card{
    border-radius: 5px;
}
.open-show{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    font-size: 12px;
    color: #ccc;
}
.close-btn{
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 14px;
    color: #848484;
}
.robot-list{
    margin-top: 10px;
    .title{
    }
}
</style>
